<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 零星采购审批</template>
                            <FormItem label="">
                                <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                    <Radio :label="3">通过审批</Radio>
                                    <Radio :label="2">未通过审批</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem v-if="Forms.status === 2" label="未通过原因" prop="reject_remark" :rules="[{required: true, message: '请输入未通过原因', trigger: 'blur'}]">
                                <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="未通过原因" />
                            </FormItem>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 采购信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2" layout="vertical">
                                <Description term="采购标题：">{{detail.title}}</Description>
                                <Description term="采购产品：">
                                    <Tag v-for="(item,index) in detail.product_list" :key="index">{{item.name}}</Tag>
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="2" layout="vertical">
                                <Description term="零星项目："><Tag>{{detail.project_name}}</Tag></Description>
                                <Description term="维保记录："><Tag>{{detail.maintain_title}}</Tag></Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="2" layout="vertical">
                                <Description term="供应商："><Tag>{{detail.company}}</Tag></Description>
                                <Description term="负责人：">{{detail.head_name}}</Description>
                                <Description term="采购金额："><Tag color="blue">{{detail.buyer_money ?? '0.00'}}</Tag></Description>
                                <Description term="合同金额："><Tag color="green">{{detail.pay_money ?? '0.00'}}</Tag></Description>
                                <Description term="合同凭证：">
                                    <Tag v-if="detail.contract" class="cursor" color="primary" @click="FileDownload(detail.contract)">点击下载合同凭证</Tag>
                                    <small v-else>未上传</small>
                                </Description>
                            </DescriptionList>
                            <div v-if="detail.proList && detail.proList.length" style="margin: 8px 0;">
                                <p v-for="(item,index) in detail.proList" :key="index" style="margin:2px 0;">{{item.product_name}}：单价 {{item.price}}，数量 {{item.num}}</p>
                            </div>
                        </Card>
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 采购说明</template>
                            <div class="textarea-wrap">{{detail.buyer_desc}}</div>
                        </Card>
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 收款信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2" layout="vertical">
                                <Description term="收款账户：">{{detail.bank_account ?? '-'}}</Description>
                                <Description term="账户实名：">{{detail.bank_real_name ?? '-'}}</Description>
                                <Description term="收款银行：">{{detail.bank_name ?? '-'}}</Description>
                                <Description term="开户地址：">{{detail.bank_address ?? '-'}}</Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">审批</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>
import {examineSmallBuyer, getSmallBuyerDetail} from "@/apis/dispersed";

export default {
    name: 'SmallBuyerExamine',
    emits: ['trueHandler'],
    data () {
        return {
            title: '零星采购审批',
            isBox: false,
            detail: [],
            site_url: this.$siteApi,
            Forms: {
                buyer_id: '',
                reject_remark: '',
                status: 3
            }
        }
    },
    methods: {
        FileDownload(url){
            if(url){
                const fileUrl = this.site_url + url;
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                this.$Message.error({ background: true, duration: 3, content: '没有资料可下载' });
            }
        },
        GetDetail(buyer_id){
            this.$store.commit('SET_LOADING', true);
            getSmallBuyerDetail(buyer_id).then(e=>{
                this.detail = e.data;
            })
        },
        show(buyer_id, title){
            this.isBox = true;
            this.title = title + ' - 零星采购审批';
            if(buyer_id){
                this.Forms.buyer_id = buyer_id;
                this.GetDetail(buyer_id);
            }
        },
        FormSubmit(){
            this.$refs['Forms'].validate((valid) => {
                if(valid){
                    this.$store.commit('SET_LOADING', true);
                    examineSmallBuyer(this.Forms).then(e=>{
                        this.$Message.success({ background: true, duration: 3, content: e.msg });
                        this.FormReset();
                        this.$emit('trueHandler');
                    })
                }
            })
        },
        FormReset(){
            this.isBox = false;
            this.title = '零星采购审批';
            this.$refs['Forms'] && this.$refs['Forms'].resetFields();
            this.Forms.buyer_id = '';
            this.Forms.status = 3;
            this.Forms.reject_remark = '';
            this.detail = [];
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
